<script>
import reBooking from '@/views/cargo/v0/RailwayExport/reBooking'

export default {
  name: 'FBARailwayExport',
  extends: reBooking
}
</script>
